module.exports = __webpack_public_path__ + "static/ohp_home-765533efc3d7aabafe90b2038a3ae01e.png";